import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Do participants need any dance experience?',
      answer: 'Not at all! Groove & Glow is designed to be inclusive and beginner-friendly. The workshop focuses on creative expression and movement, not technical dance skills. All activities are adapted to suit participants of all fitness levels and backgrounds.'
    },
    {
      question: 'What technology is required from our side?',
      answer: 'We bring all necessary technology including Unreal Engine setups, projection equipment, wearables, and feedback systems. You only need to provide a suitable venue space with basic power requirements. We handle all technical setup and teardown.'
    },
    {
      question: 'How long is the workshop?',
      answer: 'The standard workshop is a full-day experience (approximately 8 hours including breaks). However, we offer flexible durations from half-day sessions to multi-day programs, depending on your team\'s needs and objectives.'
    },
    {
      question: 'What is the ideal team size?',
      answer: 'The workshop works best with groups of 20-50 participants, allowing for meaningful interaction while maintaining the immersive experience. However, we can accommodate smaller teams (10-20) or scale up to larger company-wide events (100+) with adjusted formats.'
    },
    {
      question: 'Can the workshop be customized to our company goals?',
      answer: 'Absolutely! We work closely with your team to align the workshop with specific organizational objectives, whether that\'s improving cross-departmental collaboration, fostering innovation, building leadership skills, or enhancing overall wellbeing.'
    },
    {
      question: 'What outcomes can we expect after the workshop?',
      answer: 'Teams typically report improved communication, increased trust, enhanced creative thinking, and stronger interpersonal connections. The immersive nature creates lasting memories and positive associations that continue to benefit team dynamics long after the event.'
    },
    {
      question: 'Is this suitable for remote or hybrid teams?',
      answer: 'Yes! We offer hybrid workshop formats that blend physical and virtual elements, allowing remote team members to participate through live streaming and interactive digital components. While the in-person experience is optimal, we ensure remote participants feel fully engaged.'
    },
    {
      question: 'What is the connection to the Ultimate Freestyle War?',
      answer: 'Groove & Glow serves as Singapore\'s exclusive warm-up experience for the prestigious Ultimate Freestyle War competition in Hong Kong. While the competition is for professional dancers, we\'ve reimagined the immersive elements into an accessible, corporate-friendly format that celebrates creativity and teamwork.'
    }
  ];

  return (
    <section className="py-32 bg-[#0A0A0F]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-300 text-xl">
            Everything you need to know about Groove &amp; Glow
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-[#16213E] to-[#0F0F1A] rounded-2xl border border-cyan-400/20 overflow-hidden hover:border-cyan-400/50 transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-8 text-left cursor-pointer group"
                aria-expanded={openIndex === index}
              >
                <h3 className="text-xl font-bold text-white pr-8 group-hover:text-cyan-400 transition-colors">
                  {faq.question}
                </h3>
                <div className={`flex-shrink-0 w-10 h-10 rounded-full bg-cyan-400/20 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-cyan-400 text-2xl"></i>
                </div>
              </button>
              
              <div 
                className={`transition-all duration-300 overflow-hidden ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="px-8 pb-8">
                  <p className="text-gray-300 text-lg leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-orange-500/10 to-cyan-500/10 rounded-3xl p-10 border border-white/10">
            <h3 className="text-2xl font-bold text-white mb-4">Still Have Questions?</h3>
            <p className="text-gray-300 mb-6">We're here to help you create the perfect workshop experience for your team.</p>
            <a 
              href="#contact" 
              className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
            >
              Get Your Questions Answered
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
